import { render, staticRenderFns } from "./GraficaVueltasMundo.vue?vue&type=template&id=eedcb41e"
import script from "./GraficaVueltasMundo.vue?vue&type=script&lang=js"
export * from "./GraficaVueltasMundo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports